import React, { useEffect, useState, useMemo } from "react";
import CustomButton from "../../../AppComponent/CustomButton/CustomButton";
import { useDispatch, useSelector } from "react-redux";
import {
  getTheLevelUsersListData,
  setTheInternalDepartmentDelete_usersActions, ///delete
} from "../../../../Redux/Slice";
import { NavLink } from "react-router-dom";
import ReactTable from "../../../AppComponent/Table";
import Select from "react-select";
import Delete from "../../../AppComponent/Popup/Delete";
import Search from "@mui/icons-material/Search";
import { useNavigate } from "react-router-dom";
import _ from "lodash";
import BackImage from "../../../../Assets/AppComponent/Overall_icons/UDS Needs Image-20.svg";
import DeleteImages from "../../../../Assets/AppComponent/Overall_icons/UDS Needs Image-05.svg";
import EditImages from "../../../../Assets/AppComponent/Overall_icons/UDS Needs Image-04 (1).svg";
import DepartmentLevelUser from "./DepartmentLevelUser";
import DepartmentTables from "../../../AppComponent/DepartmentTables";
const InnerDepartmentUsers = () => {
  const dispatch = useDispatch();
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );

  const navigate = useNavigate();
  const state = useSelector((state) => state);
  const [RoleCreatePopup, setRoleCreatePopup] = useState(false);
  const [newpages, setNewpage] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [dtpageindex, setdtPageindex] = useState(1);
  const [dtpagesize, setdtPagesize] = useState(10);
  const [search, setsearch] = useState("");
  const [pageSize, setPageSize] = useState(20);
  const [DeletePOPUP, setDeletePOPUP] = useState(false);
  const [DeleteID, setDeleteID] = useState("");
  const [EditId, setEditID] = useState();
  const [sno, setsno] = useState(0);

  const [LevelUsersSelected, setLevelUserSelected] = useState("l1");

  const [LevelUsersSelectedTable, setLevelUserSelectedtable] = useState("L1");
  const [UserData, setUsersData] = useState([]);

  useEffect(() => {
    const payload = {
      search: search,
      page_size: 20,
      page: dtpageindex,
      department_id: state.NeededdatasListed.SubQueryIDs,
      user_type: LevelUsersSelected,
    };
    dispatch(getTheLevelUsersListData(payload));
  }, [
    dtpageindex,
    search,
    state.NeededdatasListed.SubQueryIDs,
    LevelUsersSelected,
  ]);

  useEffect(() => {
    if (
      state?.DepartmentLevelUsersListe?.DepartmentLevelUsersRecords != undefined
    ) {
      let UserData = [];
      if (state?.DepartmentLevelUsersListe?.DepartmentLevelUsersRecords) {
        let allUsers = [];

        state.DepartmentLevelUsersListe.DepartmentLevelUsersRecords.forEach(
          (record) => {
            const region_id = record.region_id || {};
            const state_id = record.state_id || {};
            const created_at = record.created_at || "";

            if (LevelUsersSelected === "l1" && Array.isArray(record.l1_user)) {
              const l1UsersWithRegionState = record.l1_user.map((user) => ({
                ...user,
                state_id,
                region_id,
                created_at,
                departid: record.id,
                pan_india: record.pan_india,
              }));
              allUsers = [...allUsers, ...l1UsersWithRegionState];
            } else if (
              LevelUsersSelected === "l2" &&
              Array.isArray(record.l2_user)
            ) {
              const l2User = record.l2_user[0]; // This is assumed to be the full user object, not just ID
              if (l2User && typeof l2User === "object") {
                allUsers.push({
                  ...l2User,
                  state_id: record.state_id,
                  region_id: record.region_id,
                  created_at: record.created_at,
                  departid: record.id,
                  pan_india: record.pan_india,
                });
              }
            } else if (
              LevelUsersSelected === "l3" &&
              Array.isArray(record.l3_user)
            ) {
              const l3User = record.l3_user[0];
              if (l3User && typeof l3User === "object") {
                allUsers.push({
                  ...l3User,
                  state_id: record.state_id,
                  region_id: record.region_id,
                  created_at: record.created_at,
                  departid: record.id,
                  pan_india: record.pan_india,
                });
              }
            }
          }
        );

        setUsersData(allUsers);
      }
    }
  }, [
    state?.DepartmentLevelUsersListe?.DepartmentLevelUsersRecords,
    LevelUsersSelectedTable,
  ]);

  const debouncedSearch = useMemo(
    () =>
      _.debounce((e) => {
        setsearch(e);
      }, 500),
    []
  );

  function tochange(e) {
    setsearch(e);
    debouncedSearch(e);
  }

  React.useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  const pagesize = (arg) => {
    setdtPagesize(arg);
  };
  const pageindex = (arg) => {
    //  console.log(arg, "args");
    setdtPageindex(arg);
  };

  const formatedDateListwithouttime = (dateString) => {
    const date = new Date(dateString);

    // Options for date formatting (only date)
    const dateOptions = {
      month: "short", // e.g., Dec
      day: "2-digit", // e.g., 22
      year: "numeric", // e.g., 2024
    };

    // Options for time formatting (only time)
    const timeOptions = {
      hour: "2-digit", // e.g., 02
      minute: "2-digit", // e.g., 16
      hour12: true, // e.g., AM/PM format
    };

    // Format the date and time separately
    const formattedDate = date.toLocaleDateString("en-US", dateOptions);
    const formattedTime = date.toLocaleTimeString("en-US", timeOptions);

    // Combine the formatted date and time
    return `${formattedDate}`;
  };
  const truncateText = (text, maxLength) => {
    if (text.length <= maxLength) {
      return text;
    }
    return text.substring(0, maxLength) + "...";
  };

  const handleNext = (next) => {
    setdtPageindex(next + 1);
  };

  const GotoEnteredPage = (gotopage) => {
    setdtPageindex(gotopage);
  };

  const handlePrevious = (previous) => {
    if (previous != 0) {
      setdtPageindex(previous);
    }
  };
  const HandletheActived = (e) => {
    setLevelUserSelectedtable(e);
    //  console.log(e ,"asdpuaspodu asdiausdpas d");
    if (e == "L1") {
      setLevelUserSelected("l1");
    } else if (e == "L2") {
      setLevelUserSelected("l2");
    } else if (e == "L3") {
      setLevelUserSelected("l3");
    }
  };

  const HandleDeletes = () => {
    if (DeleteID != undefined) {
      const payload = {
        DeleteId: DeleteID,
        currentPage: dtpageindex,
        user_type: LevelUsersSelected,
      };
      dispatch(
        setTheInternalDepartmentDelete_usersActions(
          payload,
          setDeletePOPUP(false)
        )
      );
    }
  };

  const columns = useMemo(() => {
    const cols = [
      {
        Header: "S.NO",
        accessor: "",
        Cell: ({ row }) => <p>{Number(sno) + row.index + 1}</p>,
      },
      {
        Header: "Name",
        accessor: "",
        Cell: ({ row }) => {
          console.log(
            row.original,
            "isupUSPO Asrow.original",
            row?.original?.first_name
          );

          return (
            <span>
              {row.original?.first_name ? row.original?.first_name : "---"}
            </span>
          );
        },
      },
      // {
      //     Header: "Email Id",
      //     accessor: "",
      //     Cell: ({ row }) => {
      //         const users = getUsers(row);
      //         return users.length > 0 ? (
      //             <span>{users.map((item) => item?.email || "---").join(" , ")}</span>
      //         ) : (
      //             <span>---</span>
      //         );
      //     },
      // },

      {
        Header: "Email Id",
        accessor: "",
        Cell: ({ row }) => {
          return <span>{row.original.email ? row.original.email : "---"}</span>;
        },
      },

      {
        Header: "Created Date",
        accessor: "",
        Cell: ({ row }) => (
          <span>
            {row.original.created_at
              ? formatedDateListwithouttime(row.original.created_at)
              : ""}
          </span>
        ),
      },
      {
        Header: "State",
        accessor: "",
        Cell: ({ row }) => (
          <span>
            {row.original.state_id?.state_name
              ? truncateText(row.original.state_id?.state_name, 30)
              : "---"}
          </span>
        ),
      },
      {
        Header: "Region",
        accessor: "",
        Cell: ({ row }) => (
          <span>
            {row.original.region_id?.region_name
              ? truncateText(row.original.region_id?.region_name, 30)
              : "---"}
          </span>
        ),
      },
      {
        Header: "Pan India",
        id: "pan_india",
        Cell: ({ row }) => (
          <span>{row.original?.pan_india ? "Yes" : "No"}</span>
        ),
      },
      {
        Header: "Actions",
        accessor: "",
        Cell: ({ row }) =>
          row.original?.id ? (
            <div className="actions" style={{ display: "flex", gap: "5px" }}>
              <button
                className="btn Status"
                onClick={() => {
                  // setEditID(row.row.original.id);
                  setEditID(row.original?.departid);
                  setRoleCreatePopup(true);
                }}
              >
                <span className="OuterActionSpan">
                  <span className="EditImages">
                    <img src={EditImages} />
                  </span>
                  <span className="ActionsList"> Edit </span>
                </span>
              </button>
              <button
                type="button"
                className="btn Status"
                onClick={() => {
                  // setDeleteID(row.row.original.id);
                  setDeleteID(row.original?.departid);
                  setDeletePOPUP(true);
                }}
              >
                <span className="OuterActionSpan">
                  <span className="EditImages">
                    <img src={DeleteImages} />
                  </span>
                  <span className="ActionsList"> Delete </span>
                </span>
              </button>
            </div>
          ) : null,
      },
    ];

    return cols.filter(Boolean); // Remove null values
  }, [sno, state.DepartmentLevelUsersListe.DepartmentLevelUsersRecords]);

  return (
    <>
      <div className={stateDisplay ? "outterContent" : "inner-Content"}>
        <div
          className="Header-Details  HeaderofTicketings row"
          style={{
            padding: "4px 20px",
            width: "98%",
          }}
        >
          <div
            class="col-12 "
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
              height: "60px",
              background: "#234492 ",
              marginBottom: "24px",
              borderRadius: "12px",
            }}
          >
            <h3
              className="TicketDasboardHeader"
              style={{ color: "#fff", marginTop: "6px" }}
            >
              Users
            </h3>
            <div className="createticketing col-sm-5">
              <button
                style={{ zIndex: "555" }}
                onClick={(e) => {
                  setRoleCreatePopup(true);
                  setEditID("");
                }}
                className=" CreatebuttonDepartments"
              >
                Create
              </button>
            </div>
          </div>
        </div>

        <div
          className="row Filters ButtonPrevious"
          style={{
            padding: "15px 28px",
            margin: "0px",
            position: "relative",
            zIndex: "30",

            marginLeft: "0px",
            marginRight: "0px",
            top: "-17px",
          }}
        >
          <div className="col">
            <button
              className="btn BackImga"
              onClick={(e) => {
                navigate("/department");
              }}
            >
              <img className="PreviousPages" src={BackImage} />
              <span></span>
            </button>
          </div>
        </div>

        <div style={{ padding: " 0px 40px", marginTop: "-26px" }}>
          <div style={{ padding: " 20px 0px" }}>
            {UserData != undefined ? (
              <DepartmentTables
                data={UserData}
                columns={columns}
                totalItems={state.DepartmentLevelUsersListe.Total_Count}
                currentPage={currentPage}
                onChange={tochange}
                setCurrentPage={setCurrentPage}
                pagesize={pagesize}
                dtpagesize={pageSize}
                dtpageindex={dtpageindex}
                pageindex={pageindex}
                onPrevious={handlePrevious}
                onNextpage={handleNext}
                GotoEnteredPage={GotoEnteredPage}
                datacount={state.DepartmentLevelUsersListe.Total_Count}
                Filter={true}
                NoFilter={true}
                setsno={setsno}
                sno={sno}
                id={"spe"}
                HandletheActived={HandletheActived}
                LevelUsersSelectedTable={LevelUsersSelectedTable}
              />
            ) : null}
          </div>
        </div>
      </div>

      {RoleCreatePopup == true && (
        <DepartmentLevelUser
          show={RoleCreatePopup}
          setShow={setRoleCreatePopup}
          currentPage={dtpageindex}
          EditId={EditId}
          getsearch={search}
          LevelUsersSelected={LevelUsersSelected}
        />
      )}

      {DeletePOPUP ? (
        <Delete
          show={DeletePOPUP}
          setShow={setDeletePOPUP}
          onSubmit={HandleDeletes}
          Content={"Do you want to delete the Department"}
        />
      ) : null}
    </>
  );
};

export default InnerDepartmentUsers;
